<template>
  <div class="register">
    <el-dialog :title="title" :visible.sync="dialogVisible2" width="30%" @close="handleClosed" :close-on-click-modal="false">
      <el-form ref="form" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="手机号:" prop="phone">
          <div class="icon">
            <img src="@/assets/img/register/icon1.png" alt />
          </div>
          <el-input v-model="form.phone" placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item label="密码:" prop="passWordFrist">
          <div class="icon">
            <img src="@/assets/img/register/icon2.png" alt />
          </div>
          <el-input v-model="form.passWordFrist" placeholder="请输入8-16位数字和字母"></el-input>
        </el-form-item>
        <el-form-item label="确认密码:" prop="passWordSecond">
          <div class="icon">
            <img src="@/assets/img/register/icon2.png" alt />
          </div>
          <el-input v-model="form.passWordSecond" placeholder="请输入8-16位数字和字母"></el-input>
        </el-form-item>
        <el-form-item label="验证码:" class="code" prop="phoneCode">
          <div class="icon">
            <img src="@/assets/img/register/icon3.png" alt />
          </div>
          <el-input v-model="form.phoneCode" placeholder="请输入验证码"></el-input>
          <el-button
            class="get-code-btn"
            @click="getCode"
            :disabled="disabledCodeBtn"
          >{{codeButton}}</el-button>
        </el-form-item>
        <div style="overflow:hidden">
          <el-form-item label="用户名:" class="name" prop="name">
            <div class="icon">
              <img src="@/assets/img/register/icon4.png" alt />
            </div>
            <el-input v-model="form.name" placeholder="请输入6-16位字符的用户名"></el-input>
          </el-form-item>
        </div>
        <el-form-item label="行业:" prop="trade">
          <div class="icon">
            <img src="@/assets/img/register/icon5.png" alt />
          </div>
          <el-select v-model="form.trade" placeholder="请选择" :popper-append-to-body="false">
            <el-option
              popper-class="select-popper"
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="职位:" prop="position">
          <div class="icon">
            <img src="@/assets/img/register/icon6.png" alt />
          </div>
          <el-input v-model="form.position" placeholder="请输入职位"></el-input>
        </el-form-item>
        <el-form-item class="button">
          <el-button type="primary" @click="onSubmit('form')" class="register-btn">完成注册</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { getMessagePwd, registerUser } from "@/api/login";
export default {
  name: "register",
  props: {
    dialogVisible: {
      default: false,
      type: Boolean
    }
  },
  watch: {
    dialogVisible(newVal) {
      this.dialogVisible2 = newVal;
      this.$refs.form && this.$refs.form.resetFields();
      clearInterval(this.timer);
      this.num = 60;
      this.codeButton = "获取验证码";
      this.disabledCodeBtn = false;
    }
  },
  data() {
    var validateTel = (rule, value, callback) => {
      var myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      if (value === "") {
        callback(new Error("请输入手机号"));
      } else if (!myreg.test(value)) {
        callback(new Error("请正确输入手机号"));
      }
      callback();
    };
    var validatePass = (rule, value, callback) => {
      var myreg2 = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/;
      if (value === "" || !myreg2.test(value)) {
        callback(new Error("请输入8-16位数字和字母"));
      }
      callback();
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.form.passWordFrist) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    var validateName = (rule, name, callback) => {
      var filter = /^[0-9A-Za-z.@\-_]{6,16}$/;
      if (filter.test(name)) {
        callback();
      } else if (name == "") {
        callback(new Error("请输入6-16位字符"));
      } else {
        callback(new Error("您的用户名格式不正确"));
        return false;
      }
    };
    return {
      title: "欢迎注册",
      codeButton: "获取验证码",
      num: 60,
      dialogVisible2: false,
      disabledCodeBtn: false, // 获取验证码点击
      timer: "",
      options: [{
          value: '1',
          label: '政府'
        }, {
          value: '2',
          label: '金融/经济相关'
        }, {
          value: '3',
          label: '科研'
        }, {
          value: '4',
          label: '民营企业'
        }, {
          value: '5',
          label: '国营企业'
        },
        {
          value: '6',
          label: '其他'
        }],
      form: {
        phone: "",
        passWordFrist: "",
        passWordSecond: "",
        phoneCode: "",
        name: "",
        trade: '1',
        position: ''
      },
      rules: {
        phone: [{ required: true, validator: validateTel, trigger: "blur" }],
        passWordFrist: [
          { required: true, validator: validatePass, trigger: "blur" }
        ],
        passWordSecond: [
          { required: true, validator: validatePass2, trigger: "blur" }
        ],
        phoneCode: [
          { required: true, message: "请输入验证码", trigger: "blur" }
        ],
        name: [{ required: true, validator: validateName, trigger: "blur" }],
        trade: [
          { required: true, message: "请选择行业", trigger: "change" }
        ],
      }
    };
  },
  methods: {
    handleClosed() {
      this.$emit("handleClosed", {
        closed: true
      });
    },
    //获取验证码
    async getCode() {
      if (this.num < 60) {
        return;
      }
      let myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      if (this.form.phone == "") {
        this.$message({
          message: "请输入手机号",
          type: "error"
        });
        return;
      } else if (!myreg.test(this.form.phone)) {
        this.$message({
          message: "请正确输入手机号",
          type: "error"
        });
        return;
      }
      let params = {
        phone: this.form.phone
      };
      let res = await getMessagePwd(params);
      if (res.status == 200) {
        this.$message({
          message: "验证码已发送",
          type: "success"
        });
        this.disabledCodeBtn = true;
        this.num = 60;
        this.timer = setInterval(() => {
          if (this.num < 2) {
            clearInterval(this.timer);
            this.disabledCodeBtn = false;
            this.codeButton = "获取验证码";
            this.num = 60;
            return;
          }
          this.num--;
          this.codeButton = this.num + "秒后重新发送";
        }, 1000);
      }
    },
    // handle() {},
    onSubmit(formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          let res = await registerUser(this.form);
          switch (res.status) {
            case 200:
              this.$message.success("注册成功");
              this.dialogVisible2 = false;
              break;
            case 614:
              this.$message.error("手机号被占用");
              break;
            case 616:
              this.$message.error("用户名被占用");
              break;
            case 619:
              this.$message.error("注册失败");
              break;
            default:
          }
        }
      });
    }
  },
  mounted() {}
};
</script>
<style scoped>
.register >>> .el-dialog__title {
  font-size: 24px;
}
.register >>> .el-dialog__header {
  margin-top: 30px;
}
.register >>> .el-dialog__body {
  padding: 30px 160px;
}
.register >>> .el-dialog {
  width: 810px !important;
  height: 700px !important;
  border-radius: 10px;
  overflow: hidden;
}
.register >>> .el-dialog__header {
  text-align: center;
}
.register >>> .el-form-item__label {
  font-size: 16px;
  color: #8c8c8c;
}
.register-btn {
  background: #ff854c;
  border: 1px solid #ff854c;
  margin: 0 auto;
  width: 150px;
  height: 42px;
  margin-left: 82px;
}
.register >>> .el-form-item__content {
  position: relative;
}
.register >>> .el-form-item__content .icon {
  position: absolute;
  top: 11px;
  left: 15px;
  z-index: 99;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.register >>> .el-input__inner {
  padding-left: 54px;
}
.code >>> .el-input {
  width: 210px;
}
.code p {
  width: 148px;
  height: 40px;
  font-size: 14px;
  color: #ff854c;
  float: right;
  border: 1px solid #ff854c;
  text-align: center;
  cursor: pointer;
  border-radius: 5px;
  margin: 0;
}
.register >>> .sex {
  float: right;
}
.register >>> .sex .el-form-item__content {
  margin-left: 20px !important;
}
.register >>> .el-radio__input.is-checked .el-radio__inner {
  border-color: #ff854c !important;
  background: #ff854c !important;
}
.register >>> .el-radio__input.is-checked + .el-radio__label {
  color: #545454;
}
.register >>> .el-input.is-active .el-input__inner,
.register >>> .el-input__inner:focus {
  border: 1px solid #ff854c !important;
}
.register >>> .el-select {
  width: 100%;
}
.button {
  margin-top: 30px;
}
.register >>> .el-radio__inner:hover {
  border-color: #ff854c !important;
}
.register >>> .el-radio {
  margin-right: 15px;
}
.success p {
  font-size: 22px;
  margin-top: 16px;
}
.success {
  margin: 130px auto 0;
  text-align: center;
}
.button2 {
  margin: 180px auto 0;
  display: block;
}
.tip {
  text-align: center;
  font-size: 14px;
  color: #ff854c;
  position: absolute;
  top: 70px;
  left: 230px;
}
.el-form-item {
  margin-bottom: 30px;
}
.get-code-btn {
  background: #fff;
  border-color: rgb(255, 133, 76);
  color: rgb(255, 133, 76);
  margin-left: 8px;
}
.get-code-btn:hover {
  background: #fff;
  border-color: rgb(255, 133, 76);
  color: rgb(255, 133, 76);
  margin-left: 8px;
}
.register .el-select >>> .el-select-dropdown {
  background: #fff!important;
}
</style>
